import React from 'react'
import Testmonials from './Testmonials'

function Main_Testmponial() {
  return (
    <div>
      <div className='container '>
        <div>
        <div id="carouselExampleFade" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner  ">
            <div class="carousel-item active ">
            <div>
            <Testmonials/>
            </div>
            </div>
            <div class="carousel-item">
            <div>
            <Testmonials/>
            </div>
            </div>
            <div class="carousel-item">
            <div>
            <Testmonials/>
            </div>
            </div>
        </div>
        <button class="carousel-control-prev slider_button" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
            <span class="carousel-control-prev-icon Testmonnial_slider_icon" Testmonnial_slider_iconen="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next slider_button" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
            <span class="carousel-control-next-icon Testmonnial_slider_icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button> 
        </div>
        </div>       
      </div>
    </div>
  )
}

export default Main_Testmponial
